import { useState } from 'react';
import { Link } from 'react-router-dom';

export default function Footer() {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');

  const handleSubscribe = async (e: React.FormEvent) => {
    e.preventDefault();
    const form = e.target as HTMLFormElement;
    const honeypot = (form.querySelector('input[name="website_alt"]') as HTMLInputElement)?.value?.trim();
    if (honeypot) {
      setStatus('success');
      return;
    }
    if (!email.trim()) return;

    setStatus('loading');
    try {
      const formData = new URLSearchParams();
      formData.append('email', email);
      await fetch('https://readdy.ai/api/form/d912vkq181e9e92u98j0', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: formData.toString(),
      });
      setStatus('success');
      setEmail('');
    } catch {
      setStatus('error');
    }
  };

  return (
    <footer className="bg-foreground-950 rounded-t-3xl mt-16 md:mt-20">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6 py-14 md:py-20">
        <div className="flex flex-col lg:flex-row gap-12 lg:gap-20">
          <div className="lg:flex-[2]">
            <h3 className="text-3xl md:text-4xl font-heading font-semibold text-white mb-3">
              Stay Updated
            </h3>
            <p className="text-foreground-400 text-sm mb-8 max-w-sm leading-relaxed">
              Get the latest Vigorbuy Spreadsheet updates, product recommendations, and shopping guides delivered to your inbox.
            </p>

            <form
              onSubmit={handleSubscribe}
              data-readdy-form
              className="max-w-sm"
            >
              <input
                type="text"
                name="website_alt"
                tabIndex={-1}
                autoComplete="off"
                aria-hidden="true"
                className="honeypot-field"
              />
              <div className="relative mb-4">
                <input
                  type="email"
                  name="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="Your email address"
                  required
                  className="w-full bg-transparent border-b border-foreground-600 pb-3 text-sm text-white placeholder:text-foreground-500 outline-none focus:border-white transition-colors"
                />
              </div>
              <button
                type="submit"
                disabled={status === 'loading'}
                className="flex items-center gap-2 px-6 py-2.5 rounded-full bg-white text-foreground-950 text-sm font-semibold whitespace-nowrap cursor-pointer hover:bg-foreground-100 transition-colors disabled:opacity-50"
              >
                {status === 'loading' ? 'Subscribing...' : 'Subscribe'}
                <i className="ri-arrow-right-line text-base"></i>
              </button>
              {status === 'success' && (
                <p className="mt-3 text-sm text-secondary-400">Thank you for subscribing!</p>
              )}
              {status === 'error' && (
                <p className="mt-3 text-sm text-primary-400">Something went wrong. Please try again.</p>
              )}
            </form>
          </div>

          <div>
            <h4 className="text-xs font-semibold uppercase tracking-wider text-foreground-400 mb-5">Quick Links</h4>
            <div className="flex flex-col gap-3">
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="text-sm text-foreground-300 hover:text-white transition-colors underline cursor-pointer"
              >
                Spreadsheet
              </a>
              <Link
                to="/articles/vigorbuy-spreadsheet-guide"
                className="text-sm text-foreground-300 hover:text-white transition-colors underline cursor-pointer"
              >
                Guides
              </Link>
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="text-sm text-foreground-300 hover:text-white transition-colors underline cursor-pointer"
              >
                Reviews
              </a>
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="text-sm text-foreground-300 hover:text-white transition-colors underline cursor-pointer"
              >
                Blog
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-xs font-semibold uppercase tracking-wider text-foreground-400 mb-5">Contact</h4>
            <div className="flex flex-col gap-2 mb-8">
              <a href="mailto:hello@vigorbuy.study" className="text-sm text-foreground-300 hover:text-white transition-colors cursor-pointer">
                hello@vigorbuy.study
              </a>
            </div>
            <h4 className="text-xs font-semibold uppercase tracking-wider text-foreground-400 mb-4">Address</h4>
            <p className="text-sm text-foreground-400 leading-relaxed">
              VigorBuy Resource Center<br />
              Online Platform Worldwide
            </p>
          </div>
        </div>

        <div className="mt-14 pt-8 border-t border-foreground-800 flex flex-col sm:flex-row items-center justify-between gap-4">
          <div className="flex items-center gap-5">
<span className="text-sm text-foreground-400">Twitter</span>
            <span className="text-sm text-foreground-400">LinkedIn</span>
            <span className="text-sm text-foreground-400">Instagram</span>
          </div>
          <p className="text-sm text-foreground-500">
            &copy; {new Date().getFullYear()} VigorBuy. All rights reserved.
          </p>
          <div className="flex items-center gap-5">
<span className="text-sm text-foreground-400">Privacy</span>
            <span className="text-sm text-foreground-400">Terms</span>
          </div>
        </div>
      </div>
    </footer>
  );
}